module.exports = __webpack_public_path__ + "img/1691026775307-image.jpg.29d1887b.webp";